module.exports = __webpack_public_path__ + "static/media/7.Passenger-Hoist.7e214e0a.webp";